import React from 'react';
import { useTranslation } from 'react-i18next';
import { resolveMediaUrl } from '../../utils/resolveMediaUrl';

// Renders an actor's avatar for a notification (follower, commenter, liker,
// mentioner, poster) given a URL/username the caller already has -- unlike
// UserAvatar.jsx, this never issues its own fetch. Notification list
// responses already bulk-resolve actor_avatar_url server-side in one query
// per page (crud_user_notification.py's _attach_actor_info), so re-fetching
// per-row here via useProfilePicture would be redundant. Same gradient-
// circle-with-initial fallback as UserAvatar.jsx for visual consistency.
const NotificationActorAvatar = ({ avatarUrl, username, size = 'w-9 h-9', textSize = 'text-sm' }) => {
  const { t } = useTranslation();
  const initial = (username || 'U').charAt(0).toUpperCase();

  if (avatarUrl) {
    return (
      <img
        src={resolveMediaUrl(avatarUrl)}
        alt={t('userAvatar.usersAvatarAlt', { username: username || t('userAvatar.genericUser') })}
        className={`${size} rounded-full object-cover flex-shrink-0`}
      />
    );
  }

  return (
    <div
      className={`${size} rounded-full bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center text-white ${textSize} font-semibold flex-shrink-0`}
    >
      {initial}
    </div>
  );
};

export default NotificationActorAvatar;
